import { createSelector } from '@reduxjs/toolkit';
import { NavigationState } from './types';
import { selectCurrentAccount } from '@/features/Auth/selectors';


const selectNavigationDomain = (state: any): NavigationState => {
    const nav = state.navigation;
    // Safe access for hybrid state
    return (nav && typeof nav.toJS === 'function' ? nav.toJS() : nav) || {
        activeServiceContext: 'recruitment',
        activeSubMenu: null,
        activeJobId: null,
        activeOrganizationId: null,
        isSidebarOpen: false
    };
};

export const selectActiveServiceContext = createSelector(selectNavigationDomain, (nav) => nav.activeServiceContext);
export const selectActiveSubMenu = createSelector(selectNavigationDomain, (nav) => nav.activeSubMenu);
export const selectActiveJobId = createSelector(selectNavigationDomain, (nav) => nav.activeJobId);
export const selectActiveOrganizationId = createSelector(selectNavigationDomain, (nav) => nav.activeOrganizationId); // NEW
export const selectIsSidebarOpen = createSelector(selectNavigationDomain, (nav) => nav.isSidebarOpen);

// NEW: SMART SELECTOR - Replaces `selectSelectedOrganization` in organizationSlice
// It looks at the active ID, and finds the fresh object inside the user's account data.
export const selectActiveOrganizationDetails = createSelector(
    [selectActiveOrganizationId, selectCurrentAccount],
    (orgId, account) => {
        if (!orgId || !account || !account.companies) return null;
        return account.companies.find((c: any) => c.id === orgId || c._id === orgId) || null;
    }
);